import { render, staticRenderFns } from "./m-social.vue?vue&type=template&id=73ef1e30"
import script from "./m-social.vue?vue&type=script&lang=js"
export * from "./m-social.vue?vue&type=script&lang=js"
import style0 from "./m-social.vue?vue&type=style&index=0&id=73ef1e30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports